export const CORE_NAVIGATION_COMPONENT_CONFIG = {
  component: null,
};
